import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createActionCreator, createBoundActionCreator, createType } from '../../../shared/state/index.state';

@Injectable()
export class AdminActions {
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  //              ACTION CREATORS
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  static GET_AVAILABLE_USER_STATUSES = createActionCreator<any>(createType('[Admin:Satellites:Surveillance] Get Available User Statuses'));
  static GET_AVAILABLE_USER_STATUSES_SUCCESS =
    createActionCreator<any>(createType('[Admin:Satellites:Surveillance] Get Available User Statuses Success'));
  static GET_AVAILABLE_USER_STATUSES_FAIL =
    createActionCreator<any>(createType('[Admin:Satellites:Surveillance] Get Available User Statuses Failed'));

  constructor(private store: Store<any>) {}

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  //              BOUND ACTIONS
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  getAvailableUserStatuses =
    createBoundActionCreator(AdminActions.GET_AVAILABLE_USER_STATUSES, this.store.dispatch.bind(this.store));
}
